import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useGetData } from "../hooks/useGetData";

const Blog = () => {
  const { data, loading } = useGetData("blogs");
  const navigate = useNavigate();
  return (
    <div className="dark">
      <Header />
      <section
        id="blogs"
        className="bg-white dark:bg-gray-900 pt-0 dark min-h-screen flex justify-center"
      >
        {loading ? (
          <div className="w-12 h-12 rounded-full animate-spin border-2 border-solid border-blue-500 border-t-transparent"></div>
        ) : (
          <div className="dark:bg-gray-900 py-24 text-white sm:py-32 ">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-2xl lg:mx-0">
                <h2 className="text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl">
                  From the blog
                </h2>
                <p className="mt-2 text-lg/8 text-white">
                  Learn how to grow your business with our expert advice.
                </p>
              </div>

              <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                {data?.map((dataItem) => (
                  <article className="flex max-w-xl flex-col items-start justify-between">
                    <div className="flex items-center gap-x-4 text-xs">
                      <time
                        datetime={new Date(dataItem?.updated).toLocaleString()}
                        className="text-gray-500"
                      >
                        {new Date(dataItem?.updated).toLocaleString()}
                      </time>
                      {dataItem?.labels.map((labels) => (
                        <p className="relative z-10 rounded-full bg-[#e62552] px-3 py-1.5 font-medium text-white hover:bg-black">
                          {labels}
                        </p>
                      ))}
                    </div>
                    <div className="group relative">
                      <h3 className="mt-3 text-lg/6 font-semibold text-#9334e9 group-hover:text-white">
                        <a href={`/blogs/${dataItem?.id}`}>
                          <span className="absolute inset-0"></span>
                          {dataItem?.title}
                        </a>
                      </h3>
                      <span
                        onClick={() => navigate(`/blogs/${dataItem?.blog?.id}`)}
                        className="text-sm/6 font-semibold text-[#9334e8]"
                      >
                        Read More <span aria-hidden="true">→</span>
                      </span>
                    </div>
                    {/* <div className="relative mt-8 flex items-center gap-x-4">
                    <img
                 x     src={dataItem?.author?.image?.url}
                      alt=""
                      className="size-10 rounded-full bg-gray-50"
                    />
                    <div className="text-sm/6">
                      <p className="font-semibold text-white">
                        <a href="#">
                          <span className="absolute inset-0"></span>
                          {dataItem?.author?.displayName}
                        </a>
                      </p>
                      {/* <p className="text-white">Co-Founder / CTO</p> */}
                    {/* </div>
                  </div>  */}
                  </article>
                ))}
              </div>
            </div>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};
export default Blog;
